// Manage flow of all booker authorization screens here
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountInfo from './AccountInfo';
import Authorize from './Authorize';
import SetupSuccess from './SetupSuccess';
import StaffLogin from './StaffLogin';

export default class RestoreSetup extends Component {
  constructor() {
    super();

    this.state = {
      isAccountInfoSaved: false,
      isSetupComplete: false,
      staffCredSaved:false,
      authorized:false
    };

    this.handleBackAction = this.handleBackAction.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { softwares: prevSoftwares } = this.props;
    const { softwares: newSoftwares } = nextProps;
    const newState = {};

    // isSavingZenotiAccountInfo: false,
    // isZenotiAccountInfoSaveSuccess: true,
    // isZenotiAccountInfoSaveFail: false,
    // if (prevSoftwares.isZenotiAccountInfoSaveSuccess) {
    //   newState.isAccountInfoSaved = true;
    // }

    if (
      prevSoftwares.isSavingZenotiAccountInfo &&
      !newSoftwares.isSavingZenotiAccountInfo &&
      newSoftwares.isZenotiAccountInfoSaveSuccess
    ) {
      newState.isAccountInfoSaved = true;
    }

    if (prevSoftwares.isSavingStaffCredentials && !newSoftwares.isSavingStaffCredentials) {
      newState.isSetupComplete = true;
    }
    console.log('prevSoftwares',prevSoftwares);
    console.log('newSoftwares',newSoftwares);
    if(!prevSoftwares.zenotiStaffCredLogin && newSoftwares.zenotiStaffCredLogin){
      newState.staffCredSaved = true
    }
    if(!prevSoftwares.isZenotiAutorization && newSoftwares.isZenotiAutorization){
      newState.authorized = true
    }

    if (Object.keys(newState).length) {
      this.setState(newState);
    }
  }

  handleBackAction(screen) {
    if (screen === 'authorize') {
      this.setState({
        isAccountInfoSaved: false,
      });
    }
  }
  skipTheStaffLogin=()=>{
    this.setState({
      isSetupComplete: true,
    });
  }

  render() {
    const { router } = this.props;
    const { isAccountInfoSaved, isSetupComplete, staffCredSaved ,authorized } = this.state;
    console.log("State",this.state);
    if (isSetupComplete) {
      // Show setup success screen
      return (
        <SetupSuccess
          onDone={() => {
            // Get Bookings Software Info
            this.props.getBookingSoftware();

            // Redirect to summary screen
            router.push('/app/setup');
          }}
          {...this.props}
        />
      );
    }

    // if (isAccountInfoSaved) {
    //   // Show Staff Add screen
    //   return (
    //     <Authorize
    //       onBack={() => {
    //         this.handleBackAction('authorize');
    //       }}
    //       {...this.props}
    //     />
    //   );
    // }
    if (isAccountInfoSaved & !authorized) {
      // Show Staff Add screen
      return (
        <Authorize
          onBack={() => {
            this.handleBackAction('authorize');
          }}
          {...this.props}
        />
      );
    }

    if (authorized) {
      return (
        <StaffLogin
          onBack={() => {
            this.handleBackAction('authorize');
          }}
          onSkip={this.skipTheStaffLogin}
          {...this.props}
        />
      );
    }

    return <AccountInfo {...this.props} />;
  }
}

RestoreSetup.propTypes = {
  getBookingSoftware: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  router: PropTypes.shape().isRequired,
};
